import { supabase } from '../supabase/config';

// Check if user already reported this item in last 24 hours
export const checkAlreadyReported = async (reportType, reportId) => {
  try {
    const currentUser = window.currentAppUser || window.currentUser;
    if (!currentUser?.uid) return false;
    
    const supabaseClient = window.supabase || supabase;
    
    const twentyFourHoursAgo = new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString();
    
    const { data, error } = await supabaseClient
      .from('reports')
      .select('id')
      .eq('reporter_id', currentUser.uid)
      .eq('type', reportType === 'user' ? 'user' : 'event')
      .eq(reportType === 'user' ? 'reported_user_id' : 'reported_event_id', reportId)
      .gte('created_at', twentyFourHoursAgo)
      .limit(1);
    
    if (error) {
      return false;
    }
    
    return data && data.length > 0;
  } catch (err) {
    return false;
  }
};

export const showReportModal = async (reportType, reportId, reportName, reportEmail = '') => {
  // Check if already reported
  const alreadyReported = await checkAlreadyReported(reportType, reportId);
  if (alreadyReported) {
    window.showToast(`You have already reported this ${reportType === 'user' ? 'user' : 'event'} in the last 24 hours.`, 'info');
    return;
  }

  window.dispatchEvent(new CustomEvent('openReportModal', {
    detail: { reportType, reportId, reportName, reportEmail }
  }));
};

window.checkAlreadyReported = checkAlreadyReported;
window.showReportModal = showReportModal;